import { render, staticRenderFns } from "./CashAccountTab.vue?vue&type=template&id=38c7d214"
import script from "./CashAccountTab.vue?vue&type=script&lang=ts"
export * from "./CashAccountTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports